var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSuccess(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 31.25,
    height: 31.25,
    viewBox: "0 0 31.25 31.25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_26952",
    "data-name": "Group 26952",
    transform: "translate(-164.375 -104)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_37724",
    "data-name": "Path 37724",
    d: "M18,2.375A15.626,15.626,0,0,1,29.049,29.049a15.626,15.626,0,0,1-22.1-22.1A15.523,15.523,0,0,1,18,2.375Zm0,29.25a13.623,13.623,0,1,0-9.635-3.99A13.536,13.536,0,0,0,18,31.625Z",
    transform: "translate(162 101.625)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37725",
    "data-name": "Path 37725",
    d: "M-1101.726,511.912l-4.758-4.743,1.412-1.417,3.338,3.327,8.92-9,1.42,1.408Z",
    transform: "translate(1279 -386.297)",
    fill: "#fff"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccess);
export default __webpack_public_path__ + "static/media/success.0031dfb79079d16f2fdb13a2b356e2b4.svg";
export { ForwardRef as ReactComponent };